<template>

    <div class="card flex flex-wrap pt-6 pb-4 px-4 lg:p-8">


        <speakol-tree-select
            id="system-fund-refund-tab-email-list"
            class="w-full mb-10 lg:mb-5 lg:w-1/2 lg:pr-8"
            label="User Email"
            placeholder="User Email"
            validation="required|email"
            :fetchFunction="fuzzySearch"
            :transformationFunction="transformationFunction"
            ref="email"
            @select="handleAccountSelected"
        >
        </speakol-tree-select>

        <speakol-select
            id="system-fund-refund-tab-payment-list"
            class="w-full mb-10 lg:mb-5 lg:w-1/2"
            label="Payment Methods"
            placeholder="Payment Method"
            v-model="paymentMethod"
            validation="required"
            :options="paymentMethodOptions"
            ref="payment-method"
        >
        </speakol-select>

        <speakol-input
            id="system-fund-refund-tab-amount-input"
            class="w-full mb-10 lg:mb-8 lg:w-1/2 lg:pr-8"
            label="Amount"
            :placeholder="amountPlaceholder"
            v-model="amount"
            hint="You need to make sure that all campaigns are paused"
            :validation="`required|decimal|min_value:1|max_value:${selectedAccountBalance}`"
            ref="amount"
            :maxLength="8"
            v-on:input="$emit('amount-change', amount)"
        >
        </speakol-input>

        <!-- handle fund click -->
        <div class="w-full">
          <vs-button id="system-fund-refund-tab-refund-button" v-on:click="handleFundClick" class="button w-full lg:w-40">Refund</vs-button>
        </div>

        <vs-popup :active.sync="activeConfirmFundPrompt" :buttons-hidden="true">
          <div class="px-6 py-10 md:p-10">
            <img
              height="34"
              width="34"
              class="mr-5 float-left"
              src="@/assets/images/account-details/Question.svg"
            />
            <div class="md:flex md:flex-col">
              <p class="prompt-title md:prompt-title mb-5 whitespace-no-wrap">Refund Confirmation</p>
              <p class="prompt-body mb-8 ml-0 md:prompt-body">
                Are you sure you want to refund $<b>{{amount}}</b> to <b>{{account ? account.name : '' }}'s</b> account via {{ paymentMethod.value }}?
              </p>

            </div>

            <div class="flex flex-wrap mt-10 md:justify-end">
              <vs-button id="system-fund-refund-tab-confirmation-yes-button" @click="handleConfirmationOk" class="w-full mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last primary-btns">Yes</vs-button>
              <vs-button
                id="system-fund-refund-tab-confirmation-no-button"
                class="w-full md:w-32 no-btn"
                text-color="#2C2C2C"
                type="border"
                @click="handleConfirmationCancel"
              >No</vs-button>
            </div>
          </div>
        </vs-popup>


      <!-- Success Poppup -->
      <vs-popup title="Success" @cancel="setDefault" :active.sync="activeSuccessPrompt" :buttons-hidden="true">
        <div class="px-8 py-10 md:p-12 flex flex-col items-center">
          <img  class="mb-10" width="100px" height="100px" src="@/assets/images/account-details/icons8-approval 1.svg">
          <p class="confirm-box-body mb-6">
            The money has been successfully refunded.
          </p>
          <vs-button id="system-fund-refund-tab-success-popup-button" v-on:click="handleConfirmationCancel" class="primary-btns w-full md:w-56">Ok</vs-button>
        </div>
      </vs-popup>

    </div>
</template>

<script>
import {isEmpty, get} from 'lodash'
export default {
  data () {
    return {
      // TODO: To be called from API
      paymentMethodOptions: [
        { text: 'Cash', value: 'Cash' },
        { text: 'Bank', value: 'Bank' },
        { text: 'Paypal', value: 'Paypal' },
        { text: 'Stripe', value: 'Stripe'},
        { text: 'Yamen', value: 'Yamen'},
        { text: 'Telr', value: 'Telr'},
        { text: 'Paytabs', value: 'Paytabs'},
        { text: 'Checkout', value: 'Checkout'},
        { text: 'Credit', value: 'Credit' }
      ],
      amountPlaceholder: 'Amount',
      amount: null,
      paymentMethod: '',
      user: null,
      account: null,
      activeConfirmFundPrompt: false,
      confirmed: false,
      activeSuccessPrompt: false,
      selectedAccountBalance: 0,
      selectedAccountMaxVat: 0
    }
  },
  watch: {
    paymentMethod (newPaymentMethod) {
      this.$emit('method-selected', newPaymentMethod)
    }
  },

  methods: {
    async handleFundClick () {
      const validPaymentMethod = await this.$refs['payment-method'].validate()
      const validAmount = await this.$refs['amount'].validate()
      const validateEmail = await this.$refs['email'].validate()
      if (validPaymentMethod && validAmount && validateEmail) {
        this.activeConfirmFundPrompt = true
      }
    },
    async handleConfirmationOk () {
      this.activeConfirmFundPrompt = false
      if (this.account) {
        const amount = this.amount
        const paymentMethod = this.paymentMethod
        const account = this.account
        try {
          await window.axios.post(`/accounts/${account.id}/refund`, {
            amount,
            payment_method: paymentMethod.value
          })

          this.activeSuccessPrompt = true
          this.$emit('refund')
        } catch (error) {
          // handle error
        }

      }
    },
    handleConfirmationCancel () {
      this.setDefault()
      this.activeConfirmFundPrompt = false
      this.activeSuccessPrompt = false
      window.location.reload()
    },
    setDefault () {
      this.$refs['payment-method'].setDefault()
      this.$refs['amount'].setDefault()
      this.$refs['email'].setDefault()
      this.selectedAccountBalance = 0
      this.amountPlaceholder = 'Amount'
      this.$emit('balance-change', 0)
      this.$emit('amount-change', 0)
      this.confirmed = false
    },
    async fuzzySearch (searchQuery) {
      const { data } = await window.axios.get(`/users/${searchQuery}/accounts/personal`)
      return data.filter((obj) => !isEmpty(obj.personal_accounts))
    },
    transformationFunction (user) {
      const userId = user.id
      const userEmail = user.email
      const userAccounts = user.personal_accounts
      return {
        id: userId,
        label: userEmail,
        children: userAccounts.map((account) => {
          const accountName = account.name
          const accountId = account.id
          return {
            id: accountId,
            label: accountName,
            account,
            user
          }
        })
      }
    },

    handleAccountSelected (node) {
      const { user, account } = node
      this.selectedAccountMaxVat = get(account, 'balance[0].vat', 0)
      const selectedAccountBalance = get(account, 'balance[0].balance', 0)
      this.selectedAccountBalance = selectedAccountBalance
      this.amountPlaceholder = `${selectedAccountBalance} is the maximum amount`
      this.$emit('account-selected', account)
      this.user = user
      this.account = account
    }


  }
}
</script>


<style lang="scss" scoped>

    .no-btn {
      border: 2px solid #d9d9d9;
    }

    .card {
      background: #fff;
      border-radius: 20px;
      border: 1px solid #f2f2f2;
      border-radius: 15px;
    }

    .button {
      background: #0092d7;
      border-radius: 3px;
      height: 40px;
    }

    .radio-btn {
      width: 15px;
      height: 15px;
    }

    .prompt-title {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      letter-spacing: 0.1px;
      color: #2c2c2c;
    }

    .prompt-body {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: rgba(0, 0, 0, 0.56);
    }

    .prompt-check {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: rgba(0, 0, 0, 0.56);
    }

    @media (min-width: 768px) {
      .md\:prompt-title {
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        letter-spacing: 0.1px;
        color: #2c2c2c;
      }

      .md\:prompt-body {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        color: rgba(0, 0, 0, 0.56);
      }
    }

</style>
